import { useEffect, useState } from "react";
import { backend_url } from "../App";
import { menuItems as builtInCategories } from "../Constants/menuItems";

const PREFIX = "/collections/";
const slugOf = (path) => ((path || "").startsWith(PREFIX) ? path.slice(PREFIX.length) : "");
const same = (a, b) => String(a || "").toLowerCase() === String(b || "").toLowerCase();

// Built-in category list + anything added in Admin → HomePage → Website Menu,
// so products can be put into new menu entries. Nothing built-in is removed.
const mergeSiteMenu = (siteItems) => {
  const merged = builtInCategories.map((c) => ({ ...c, dropdown: [...(c.dropdown || [])] }));
  const allSubValues = (c) => c.dropdown.flatMap((d) => [d.value, ...(d.subcategories || []).map((s) => s.value)]);

  siteItems.forEach((item) => {
    if (item.priceFilter || !item.category) return;
    let cat = merged.find((c) => same(c.value, item.category));
    if (!cat) {
      cat = { label: item.label, value: item.category, dropdown: [] };
      merged.push(cat);
    }
    const entries = item.dropdown
      ? item.dropdown.map((d) => ({ label: d.label, value: slugOf(d.path) }))
      : [{ label: item.label, value: slugOf(item.path) }];
    entries.forEach((e) => {
      if (e.value && !allSubValues(cat).some((v) => same(v, e.value))) cat.dropdown.push(e);
    });
  });
  return merged;
};

const useCategoryMenu = () => {
  const [menu, setMenu] = useState(builtInCategories);

  useEffect(() => {
    let cancelled = false;
    fetch(`${backend_url}/api/site-menu`)
      .then((r) => r.json())
      .then((data) => {
        if (!cancelled && data.success && Array.isArray(data.items)) setMenu(mergeSiteMenu(data.items));
      })
      .catch(() => { /* keep built-in list */ });
    return () => { cancelled = true; };
  }, []);

  return menu;
};

export default useCategoryMenu;
